export default __webpack_public_path__ + "static/planet-9661afeec6ba70d2950a492740262a98.svg";